import React from 'react';
import { Switch } from 'react-router';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import { Components as Auth } from '@ers/authorization';

export const RouterContext = React.createContext({});

const RoutingContainer = ({ children }) => (
    <Router>
        <Switch>
            <Route path="/signin">
                <Auth.CallbackPage />
            </Route>
            <Route path="/silent-renew">
                <Auth.RenewPage />
            </Route>
            <Route path="/signout">
                <Auth.SignoutPage />
            </Route>
            {children}
        </Switch>
    </Router>
);

export default RoutingContainer;
